/* eslint-disable no-new */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import VueLazyload from 'vue-lazyload';

import messages from '../lang/index';
import ArticleIndex from '../components/article/ArticleIndex.vue';

Vue.use(VueApollo);
Vue.use(VueI18n);
Vue.use(VueLazyload, {
  lazyComponent: true
});


Vue.prototype.$isMobile = window.screen.width <= 599;
Vue.prototype.$isDesktop = window.screen.width > 599;

const csrfToken = document.head.querySelector('[name=csrf-token]').content;

const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
  }),
});

document.addEventListener('DOMContentLoaded', () => {
  const allData = document.getElementById('allData').dataset;
  const props = {
    initialArticles: JSON.parse(allData.articles),
    authorId: Number(allData.authorId),
    photographer: allData.photographer,
    designer: allData.designer,
    categoryName: allData.categoryname,
    categorySlug: allData.categoryslug,
    locale: allData.locale,
    country: allData.country,
    showConnect: allData.showconnect === 'true',
    action: allData.action,
    featured: allData.featured === 'true',
    countryNewsletterId: allData.countrynewsletterid,
    locale: allData.locale,
  };

  const supportedLocales = ['en', 'cn'];
  let locale = props.locale;
  if (!supportedLocales.includes(locale)) {
    locale = 'en';
  }

  const i18n = new VueI18n({
    locale,
    fallbackLocale: 'en',
    messages,
  });

  new Vue({
    el: 'app',
    apolloProvider,
    i18n,
    render: h => h(ArticleIndex, { props }),
  });
});
